module.exports = __webpack_public_path__ + "assets/icons/ic_arrow_back-47b6.svg";